const wowApp = require('angular').module('wowApp.common');

wowApp.controller('PageMetadataController', ['$location', 'PageMetadataService', require('./page-metadata-controller')]);

wowApp.service('PageMetadataService', ['Restangular', '$location', '$state', '$q', 'GtmService', require('./page-metadata.service')]);



// WEBPACK FOOTER //
// ./src/common/pagemetadata/index.js